// extracted by mini-css-extract-plugin
export default {"overlay":"zt-z","bodyOpen":"At-z","content":"Bt-z","header":"Ct-z","close":"Dt-z","closeNoHeading":"Et-z"};